import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { TimelineHttpResponse } from '../models/timeline.model';
import { TimelineApi } from './timeline.api';

@Injectable({
  providedIn: 'root',
})
export class PersonalTimelineApi extends TimelineApi {
  constructor(http: HttpClient) {
    super(http);
  }

  getTimelineFeed(pageNumber, limit: number = 15): Observable<TimelineHttpResponse> {
    const params = new HttpParams()
      .set('page', pageNumber)
      .set('limit', limit)
      .set('includeFreeRide', true)
      .set('includeWorkout', true)
      .set('includeGpsOnly', true);
    return this.http.get<TimelineHttpResponse>(environment.api.timeline.personal, { params });
  }
}
